import { render, staticRenderFns } from "./CdbCustomerPassportPage.vue?vue&type=template&id=4d773de7&scoped=true&"
import script from "./CdbCustomerPassportPage.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerPassportPage.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerPassportPage.vue?vue&type=style&index=0&id=4d773de7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d773de7",
  null
  
)

export default component.exports